module.exports = __webpack_public_path__ + "img/plan04_pop.c0447ed1.png";